<template>
    <b-modal
        v-model="modalVisible"
        title="Add Customer"
        size="lg"
        @ok="createCustomer"
        ok-title="Add Customer"
        no-close-on-backdrop
        hide-footer
    >
        <b-form>
            <b-form-group id="input-group-code" label="Code:" label-for="code">
                <b-input
                    id="code"
                    name="code"
                    v-model="model.code"
                    :error="errors.first('code')"
                    type="text"
                ></b-input>
            </b-form-group>

            <b-form-group
                id="input-group-name"
                label="Name:"
                label-for="input-name"
            >
                <b-input
                    id="input-name"
                    v-model="model.name"
                    :error="errors.first('name')"
                    v-validate="'required'"
                    type="text"
                ></b-input>
            </b-form-group>

            <b-form-group
                id="input-group-email"
                label="Email address:"
                label-for="email"
            >
                <b-input
                    id="email"
                    name="email"
                    v-model="model.email"
                    :error="errors.first('email')"
                    v-validate="'required|email'"
                    type="email"
                ></b-input>
            </b-form-group>

            <b-form-group
                id="input-group-phone"
                label="Telephone:"
                label-for="phone"
            >
                <b-input
                    id="phone"
                    name="phone"
                    v-model="model.phone"
                    :error="errors.first('phone')"
                    type="tel"
                ></b-input>
            </b-form-group>

            <location-section
                ref="locationSection"
                v-model="model.location_section_id"
                :hide-controls="true"
                title="Location"
                @update-section-model="updateSectionEvent"
            ></location-section>

            <b-form-row class="mt-4">
                <b-col>
                    <b-button variant="warning" @click="modalVisible = false"
                        >Cancel</b-button
                    >
                    <b-button variant="primary" @click="createCustomer"
                        >Save</b-button
                    >
                </b-col>
            </b-form-row>
        </b-form>
    </b-modal>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'

import locationMixins from '@/mixins/locationMixins'

import LocationSection from '@/views/Location/LocationSection'
export default {
    name: 'create-customer-form',
    components: { LocationSection },
    mixins: [popupMixins, locationMixins],
    props: ['value'],
    data: () => {
        return {
            modalVisible: false,
            model: {
                code: '',
                name: '',
                email: '',
                phone: '',
                location_section_id: null,
                location: null,
                section_name: null,
            },
            submitting: false,
            hasErrors: false,
        }
    },

    computed: {
        customer() {
            return this.$store.state.customers.item
        },
    },
    watch: {
        value: function (val) {
            console.log('value:', val)
            this.modalVisible = val
            if (val === false) {
                this.model = {
                    code: '',
                    name: '',
                    email: '',
                    phone: '',
                    location_section_id: null,
                    location: null,
                    section_name: null,
                }
            }
        },
    },
    mounted: function () {
        this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            console.log('Modal is about to be shown', bvEvent, modalId)
        })
        this.$root.$on('bv::modal::hide', () => {
            this.$emit('input', false)
        })
        // setTimeout(() => {
        //     this.$refs.map.mapObject.invalidateSize()
        //     console.log('update')
        // }, 1000)
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },

        async createCustomer(evt) {
            console.log('evt', evt)
            evt.preventDefault()
            console.log('this.model', this.model)

            const model = {
                ...this.model,
                ...(this.sectionLocationEventData || {}),
            }
            try {
                const valid = await this.$validator.validate()
                if (!valid) throw new Error('Entry Not Valid')
                this.submitting = true
                await this.$store.dispatch('customers/create', model)
                this.modalVisible = false
                await this.$nextTick()
                this.$emit('success', { ...this.customer })
            } catch (e) {
                this.doToast('Error Detected', e.message, 'warning')
            } finally {
                this.submitting = false
            }
        },
    },
}
</script>
